<header class="d-print-none">
  <sc-skip-link></sc-skip-link>
  <nav class="navbar navbar-expand-xl bg-primary d-flex">
    <div class="navbar-brand me-0 me-lg-3">
      <img src="assets/images/ulogo.png" class="d-inline-block img-fluid align-middle" alt="" style="height: 52px">
      <span class="header-text d-sm-none ms-lg-2 align-middle">Software Catalog</span>
      <span class="header-text d-none d-sm-inline ms-2 align-middle">Software Catalog</span>
    </div>

    <div class="d-flex">
      <button (click)="toggleSearch()"
              class="navbar-toggler btn btn-primary software-search-button me-1 px-2"
              [attr.aria-expanded]="isSearching">
        <app-search-icon [size]="2"></app-search-icon>
      </button>
      <button [routerLink]="'/cart'" class="navbar-toggler btn btn-primary me-1 px-2">
        <app-cart-icon [size]="2"></app-cart-icon>
        <app-cart-badge></app-cart-badge>
      </button>
      <button class="navbar-toggler btn btn-primary px-1"
              type="button"
              (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation">
        <app-list-icon [size]="3"></app-list-icon>
      </button>
    </div>

    <div class="collapse navbar-collapse"
         id="navbarNavAltMarkup"
         [attr.aria-expanded]="!isCollapsed"
         [ngClass]="{'d-none': isCollapsed, 'd-block show in': !isCollapsed}">
      <div class="navbar-nav">
        <a class="nav-item nav-link" [routerLink]="['/']" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact:true}">Home</a>
        <a class="nav-item nav-link" [routerLink]="['/account-history']" routerLinkActive="active">Order History</a>
        <a class="nav-item nav-link" [routerLink]="['/downloads']" routerLinkActive="active">Download Again</a>
        <a class="nav-item nav-link" href="https://software.utah.edu/return-policy.php" target="_blank">Returns</a>
        <a class="nav-item nav-link" href="https://uitutah.co1.qualtrics.com/jfe/form/SV_cVda1HzbjBTztTT"
           target="_blank">Submit Feedback</a>
        <a class="nav-item nav-link d-xl-none" [routerLink]="[]" (click)="logout()" id="menu-logout-link">Logout</a>
      </div>
    </div>

    <div class="d-none d-xl-inline">
      <button (click)="toggleSearch()"
              class="btn btn-primary me-1 software-search-button"
              [attr.aria-expanded]="isSearching">
        <app-search-icon [size]="2"></app-search-icon>
      </button>
      <button [routerLink]="'/cart'" class="btn btn-primary me-1">
        <app-cart-icon [size]="2"></app-cart-icon>
        <app-cart-badge></app-cart-badge>
      </button>
      <app-navbar></app-navbar>
    </div>

  </nav>
</header>
